import { SidebarLayoutNew } from '../components/sidebar-layout-new'
import { BreadcrumbsNew } from '../components/breadcrumbs'
import { Fragment } from 'react/jsx-runtime'
const pages = [
  { name: "Product Details", href: "/product-details", current: true },
];
export default function ProductDetails() {
  return (
    <Fragment>
      <SidebarLayoutNew selected_menu="product-details">
        <BreadcrumbsNew pages={pages} />
       </SidebarLayoutNew>
    </Fragment>
  );
}